/* eslint-disable prettier/prettier */
export const loginUser = (state, {user,token,roles})=>{
    if(token){
        localStorage.setItem("token", token)
        state.token = token
    }
    state.user=user
    state.rol=roles
    state.status="authenticated"
    localStorage.setItem("roles",roles)
    localStorage.setItem("user",JSON.stringify(user))
}

export const logout = (state)=>{
    state.token = null
    state.user=null
    state.status="not-authenticated"
    localStorage.removeItem("token")
    localStorage.removeItem("roles")
    localStorage.removeItem("user")
}
